import React from 'react';
import './Cards.css';

const cardData = [
  {
    "image": "https://sendbird.imgix.net/cms/Frame-1000008902-2-1.webp?wm=webp&auto=compress&lossless=0&fit=crop&w=780",
    "title": "Professional services",
    "description": "Benefit from our forward deployment team's expertise to meet your AI needs.",
    "textColor": "white"
  },
  {
    "image": "https://sendbird.imgix.net/cms/pexels-rdne-9034704-2-1-1.webp?wm=webp&auto=compress&lossless=0&fit=crop&w=780",
    "title": "Global customer success",
    "description": "Receive dedicated support from onboarding to renewal, access to best practices.",
    "textColor": "white"
  },
  {
    "image": "https://sendbird.imgix.net/cms/pexels-cottonbro-5076522-3-1.webp?wm=webp&auto=compress&lossless=0&fit=crop&w=780",
    "title": "24/7 technical support",
    "description": "Get the help you need, when you need it on digital channels or in-person.",
    "textColor": "black"
  },
  {
    "image": "https://sendbird.imgix.net/cms/Tailored-SLA-plans_2025-01-22-09.webp?wm=webp&auto=compress&lossless=0&fit=crop&w=780",
    "title": "Tailored SLA plans",
    "description": "Enterprise SLA to keep your business running smoothly when it matters most.",
    "textColor": "black"
  }
];

const Cards = () => {
  return (
    <div className="card-grid-container">
      <div className="main-content">
        <h3 className="main-title">Enterprise support for AI you deserve.</h3>
        <p className="main-description">
          Our team combines years of expertise in AI, machine learning, prompt engineering, chat, and system integrations to help <br/> you confidently design and deploy your AI agents.
        </p>
      </div>
      <div className="card-grid">
        {cardData.map((card, index) => (
          <div 
            className="card" 
            key={index}
            style={{ backgroundImage: `url(${card.image})` }}
          >
            <div className="card-content-wrapper">
              <div className="card-content">
                <h4 className="card-title" style={{ color: card.textColor }}>{card.title}</h4>
                <p className="card-description" style={{ color: card.textColor }}>{card.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Cards;